<template>
  <v-btn
    v-if="justSent"
    icon
    @click.stop
  >
    <v-icon color="green darken-1">
      mdi-check
    </v-icon>
  </v-btn>
  <v-btn
    v-else
    :loading="loading"
    :disabled="disabled || employeeList.length === 0"
    color="primary"
    icon
    @click.stop="isOpened = true"
  >
    <v-icon>
      mdi-email-outline
    </v-icon>
    <v-dialog
      v-model="isOpened"
      activator="parent"
      width="500"
    >
      <v-card>
        <v-card-title>{{ $t('common.confirmation') }}</v-card-title>
        <v-card-text>{{ $t('course_report.send_confirmation') }}</v-card-text>
        <v-data-table
          :items="employeeList"
          hide-details
          hide-default-footer
          class="elevation-0"
        >
          <template #item="{item: employee}">
            <tr>
              <td>
                <v-checkbox
                  readonly
                  hide-details
                  dense
                  :ripple="false"
                  color="green darken-2"
                  input-value="true"
                  :label="employee.name"
                />
              </td>
            </tr>
          </template>
        </v-data-table>

        <v-card-actions class="mb-2 mt-4">
          <v-spacer />
          <v-btn
            density="default"
            variant="text"
            elevation="0"
            @click="isOpened = false"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            @click="() => {
              isOpened = false
              bulkSendReminderEmail(employeeList)
            }"
          >
            {{ $t('course_report.send_mail') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
import moment from 'moment-timezone'
import QUATSError from '../../../plugins/error'

export default {
  props: {
    seminar: {
      required: true,
      type: Object
    },
    disabled: {
      required: true,
      type: Boolean
    }
  },

  data() {
    return {
      justSent: false,
      isOpened: false,
      loading: false,
      employeeList: []
    }
  },

  created() {
    const { employees } = this.seminar
    this.employeeList = employees.filter(employee => {
      if (this.assertEmployeeEligibleForReminder(employee)) {
        return {
          name: employee.name,
          email: employee.email,
          start_date: employee.start_date,
          end_date: employee.end_date,
          is_post: employee.post,
          is_pre: employee.pre,
          seminar_name: employee.seminar_name
        }
      }
    })
  },

  methods: {
    assertEmployeeEligibleForReminder(employee) {
      const today = moment()
      const seminarStartDate = moment.tz(employee.start_date, 'Asia/Tokyo')

      const isEligibleForPre = today < seminarStartDate && !employee.pre
      const isEligibleForPost = today >= seminarStartDate && !employee.post
      return isEligibleForPost || isEligibleForPre
    },

    bulkSendReminderEmail(employeeList) {
      if (employeeList.length > 0) {
        this.loading = true
        window.axios.post('/api/employee-course-report/seminar/send/email', {
          employee_list: employeeList
        })
          .then(() => {
            this.$store.commit('snackbar/successSnackbar', [this.$t('course_report.send_success_message')])
          })
          .catch((err) => {
            this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
          })
          .finally(() => {
            this.loading = false
            this.justSent = true
            setTimeout(() => {
              this.justSent = false
            }, 1000)
          })
      }
    }
  }
}
</script>

<style scoped>

</style>
